var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaantryPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#1CB978"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 7.75H10.375V25.25H8.625V7.75ZM14.75 11.25H20.875V13H14.75V11.25ZM14.75 14.75H20.875V16.5H14.75V14.75Z",
    fill: "#023A22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.625 7.75H11.25V25.25H22.625C23.5901 25.25 24.375 24.4651 24.375 23.5V9.5C24.375 8.53487 23.5901 7.75 22.625 7.75ZM22.625 23.5H13V9.5H22.625V23.5Z",
    fill: "#023A22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaantryPrint);
export default __webpack_public_path__ + "static/media/paantry-print.fcfc9dd1087e10e4e02443d5a12be573.svg";
export { ForwardRef as ReactComponent };